<mat-card>
  <div class="back-link">
    <a (click)="goBack()"><mat-icon>chevron_left</mat-icon><span translate="pushbox/back-pending"></span></a>
  </div>

  <div class="task-list-container">
    <app-task-list [taskListConfiguration]="taskListConfiguration" [taskListMode]="taskListMode"></app-task-list>
  </div>
</mat-card>
